function isEditableTarget(target: EventTarget | null): target is HTMLElement {
  if (!target || !(target as any).tagName) return false;
  const el = target as HTMLElement;
  const tag = el.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || (el as any).isContentEditable;
}

/**
 * Some UI/drag libraries (or injected scripts) disable text selection globally via:
 * - document.onselectstart = () => false
 * - element.onselectstart handlers
 * - capture listeners that call preventDefault on "selectstart"
 *
 * This function restores *native* selection behavior for editable fields.
 */
export function applySelectionFix() {
  // Clear DOM0 handlers if they exist
  try {
    (document as any).onselectstart = null;
  } catch {}
  try {
    (document.documentElement as any).onselectstart = null;
  } catch {}
  try {
    (document.body as any).onselectstart = null;
  } catch {}

  // Ensure editable fields are not blocked by other listeners.
  // We do NOT preventDefault here; we only stop propagation so later handlers
  // (often global blockers) can't cancel selection.
  document.addEventListener(
    "selectstart",
    (e) => {
      const t = e.target as HTMLElement | null;
      if (!isEditableTarget(t)) return;
      e.stopPropagation();
      (e as any).stopImmediatePropagation?.();
    },
    true,
  );
}

